import { all } from "redux-saga/effects";
import { watchLoginSaga } from "./auth/authSaga";
import { watchAssignedBookings } from "./booking/bookingSaga";
import { watchDriverAsync } from "./driver/driverSaga";
import { watchPricingAsync } from "./pricing/saga";
import { watchRoutePricingAsync } from "./routePrice/routePriceSaga";

export function* rootSaga() {
  yield all([
    watchLoginSaga(),
    watchAssignedBookings(),
    watchDriverAsync(),
    watchRoutePricingAsync(),

    // Extranet Saga Pricing
    watchPricingAsync(),
  ]);
}
